import { Component } from '@angular/core';
import { LoginService } from './services/login.service';
import { GlobalService } from './services/global.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  host: { '( window: resize )': 'onResize( $event )' }
})
export class AppComponent {
  
    constructor ( 
    	private loginService: LoginService, 
    	private global: GlobalService 
    	) { 
        this.loginService.checkLocalStorage( );
    }

    onResize( event ) { this.global.updateWindowResize( event.target.innerWidth ); }
}



// WEBPACK FOOTER //
// /root/anvel/angular/app/app.component.ts